module.exports = __webpack_public_path__ + "img/chart_stage.f9443091.svg";